import type { ReactNode, VFC } from "react";
import { createContext, useState, useEffect } from "react";

import { fetchCustomEmojis } from "../../fetchCustomEmojis";
import type { EmojiItem } from "../../types";

import { kibelaContext } from "~/client/utils/kibelaContext";

export const CustomEmojiContext = createContext<ReadonlyArray<EmojiItem>>([]);

type Props = {
  children: ReactNode;
};

export const CustomEmojiProvider: VFC<Props> = ({ children }) => {
  const [customEmojis, setCustomEmojis] = useState<ReadonlyArray<EmojiItem>>([]);

  useEffect(() => {
    if (kibelaContext.guest) {
      return;
    }

    // NOTE: If we upgrade to React18, we don't need to check mount, but until then, we are checking it because the test will fail.
    // ref: https://zenn.dev/so_nishimura/articles/c4df97cd1937c2
    let isMounted = true;

    fetchCustomEmojis().then((emojis) => {
      if (isMounted) {
        setCustomEmojis(emojis);
      }
    });

    return () => {
      isMounted = false;
    };
  });

  return <CustomEmojiContext.Provider value={customEmojis}>{children}</CustomEmojiContext.Provider>;
};
